import { render, staticRenderFns } from "./UOM.vue?vue&type=template&id=51a59bfb&"
import script from "./UOM.vue?vue&type=script&lang=js&"
export * from "./UOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports